import React from "react";
import { Link } from "react-router-dom";
import PageLayout from "@/components/layout/PageLayout";
import Seo from "@/components/foundation/Seo";
import Container from "@/components/foundation/Container";
import FadeIn from "@/components/foundation/FadeIn";
import Button from "@/components/foundation/Button";
import GridPattern from "@/components/foundation/GridPattern";
import GlowOrb from "@/components/foundation/GlowOrb";

export default function NotFound() {
  return (
    <PageLayout>
      <Seo
        title="ZenMe Capital · Page Not Found"
        description="The page you're looking for doesn't exist or has moved."
        path="/404"
      />
      <div
        className="relative flex min-h-[calc(100vh-4rem)] items-center overflow-hidden"
        data-testid="page-not-found"
      >
        <GridPattern variant="dots" size={28} opacity={0.45} />
        <GlowOrb
          color="emerald"
          size={420}
          intensity={0.18}
          className="-top-32 left-1/2 -translate-x-1/2"
        />

        <Container className="relative z-10 py-24 sm:py-32">
          <div className="mx-auto flex max-w-2xl flex-col items-start gap-6">
            <FadeIn>
              <span className="inline-flex items-center gap-2 rounded-full border border-white/[0.08] bg-white/[0.02] px-3 py-1 font-mono text-[11px] uppercase tracking-[0.16em] text-text-muted">
                <span className="h-1.5 w-1.5 rounded-full bg-brand-emerald" />
                Error 404
              </span>
            </FadeIn>

            <FadeIn delay={0.05}>
              <h1
                className="font-display text-5xl font-semibold tracking-tight text-white sm:text-6xl lg:text-7xl"
                data-testid="not-found-title"
              >
                Page not found
              </h1>
            </FadeIn>

            <FadeIn delay={0.1}>
              <p className="max-w-xl text-base text-text-secondary sm:text-lg">
                The page you&rsquo;re looking for doesn&rsquo;t exist or has moved. Let&rsquo;s get
                you back to something useful.
              </p>
            </FadeIn>

            <FadeIn delay={0.15}>
              <div className="mt-2 flex flex-wrap gap-3">
                <Link to="/">
                  <Button variant="primary" data-testid="not-found-home-btn">
                    Back to home
                  </Button>
                </Link>
                <Link to="/resources">
                  <Button variant="secondary" data-testid="not-found-resources-btn">
                    Browse resources
                  </Button>
                </Link>
              </div>
            </FadeIn>
          </div>
        </Container>
      </div>
    </PageLayout>
  );
}
